<template>
  <div :class="classes" >
    <pt-page-title :title="pageTitle"></pt-page-title>
    <a v-if="!externalType" :href="externalURL"  id="openNew" target="_blank">请点击跳转到新页面</a>
    <div v-else  v-loading="loading||iframeLoading">
    <template v-if="(externalType&&authCoolie)||true">
        <iframe ref="iframe" v-if="pageUrl" :src="pageUrl+(externalType?'?auth='+authCoolie:'')"
        :class="$style['pt-claim-application-iframe']" frameborder="0" @load="iframeLoad()" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals
        allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"></iframe>
    </template>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-claim-lifeban'

export default {
  name: 'pt-claim-lifeban',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    authCoolie: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    externalType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      pageTitle: '',
      pageUrl: '',
      menuList: [],
      iframeLoading: false,
      externalURL: ''
    }
  },
  watch: {
    '$route': {
      handler: function (val) {
        if (val) {
          this.pageUrl = null
          this.$nextTick(_ => {
            this.getTitleAndUrl(val.query)
            if (val.query) {
              this.getPageTitle()
            }
          })
        }
      },
      immediate: true
    },
    '$route.query': {
      handler: function (val) {
        this.iframeLoading = true
        if (this.externalType) {
          this.$emit('getLoginDaishu')
        }
      }
    },
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
        if (this.pageUrl) {
          this.getPageTitle()
        }
      },
      immediate: true
    }
  },
  methods: {
    iframeLoad (val) {
      console.log('iframeLoad')
      this.iframeLoading = false
    },
    // 根据路由判断页面title和iframe链接
    getTitleAndUrl (query) {
      this.pageUrl = query && query.url
    },
    getPageTitle () {
      let url = decodeURIComponent(window.location.href)
      let externalURL
      if (url.includes('?')) {
        let arr = url.split('?')
        externalURL = arr[1]
        if (externalURL.includes('url=')) {
          let arrNew = externalURL.split('url=')
          externalURL = arrNew[1]
        }
      }
      this.externalURL = externalURL
      this.menuList.forEach(element => {
        if (element.children && element.children.length > 0) {
          element.children.forEach(etem => {
            if (etem.external && (this.pageUrl === etem.url || etem.url === externalURL)) {
              this.pageTitle = etem.displayName
            }
          })
        }
      })
    }
  },
  created () {
    this.iframeLoading = true
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-claim-application-iframe{
    width: 100%;
    height: 90vh;
}
</style>
